import React, { useState, useMemo } from 'react';

import { useContact } from '@hooks/API/Contact/UseContact';

import ContactUserForm from '@components/ContactUsersDrawer/ContactUserForm';
import ContactUsers from '@components/ContactUsersDrawer/ContactUsers';
import { Loading } from '@components/Gui/Loading';
import { NwAddButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDrawer from '@components/Gui/NwDrawer';

const ContactUsersDrawer = ({ onClose, disable, contactID }) => {
    const { data: currentContact } = useContact(contactID);
    const [viewMode, setViewMode] = useState('LISTING');
    const [touchForm, setTouchForm] = useState(false);

    const handleCloseUserForm = () => {
        setViewMode('LISTING');
    };

    const { bookerUsers, scouterUsers } = useMemo(() => {
        let bookerUsers = [];
        let scouterUsers = [];
        if (currentContact) {
            bookerUsers = currentContact.Users.filter((user) => user.RoleName === 'Booker');
            scouterUsers = currentContact.Users.filter((user) => user.RoleName === 'Scouter');
        }
        return { bookerUsers, scouterUsers };
    }, [currentContact]);

    const isModel = useMemo(() => {
        if (currentContact) {
            return currentContact.ContactType === 'Model';
        }
        return false;
    }, [currentContact]);

    return (
        <NwDrawer title={`Bookers ${isModel ? ' / Scouters' : ''}`} onClose={onClose} whiteBg={false}>
            {currentContact ? (
                <>
                    {!disable && (
                        <div className="drawer-toolbar-container">
                            <NwAddButton
                                primary
                                onClick={() => setViewMode('INSERTING')}
                                label={`Add a new booker ${isModel ? ' / scouter' : ''}`}
                            />
                        </div>
                    )}
                    <div className="drawer-content standard">
                        {isModel ? (
                            <>
                                <NwCard title="Bookers">
                                    <ContactUsers
                                        isModel
                                        users={bookerUsers}
                                        readOnly={disable}
                                        contactID={contactID}
                                    />
                                </NwCard>
                                <NwCard title="Scouters">
                                    <ContactUsers
                                        isModel
                                        users={scouterUsers}
                                        readOnly={disable}
                                        contactID={contactID}
                                    />
                                </NwCard>
                            </>
                        ) : (
                            <NwCard title="Bookers">
                                <ContactUsers users={currentContact.Users} readOnly={disable} contactID={contactID} />
                            </NwCard>
                        )}
                    </div>
                </>
            ) : (
                <Loading textBlack />
            )}
            {viewMode === 'INSERTING' && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    title="Add Contact User"
                    onClose={handleCloseUserForm}
                >
                    <ContactUserForm
                        isModel={isModel}
                        contactID={currentContact.ID}
                        onCancel={handleCloseUserForm}
                        onUpdated={handleCloseUserForm}
                        onTouchForm={setTouchForm}
                    />
                </NwDrawer>
            )}
        </NwDrawer>
    );
};

export default ContactUsersDrawer;
